import React, {
  Suspense,
} from 'react';
import {
  Router,
} from 'react-router-dom';
import {
  hot,
  cold,
  setConfig,
} from 'react-hot-loader';
import {
  ThemeProvider,
} from 'styled-components';
import {
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';
import {
  history,
} from 'web-history';

import {
  Spinner,
  Analytics,
  FreshbotsWidget,
} from 'web-components';
import {
  Flex,
  GlobalStyle,
  configureTheme,
} from 'web-styled';

import Helmet from './Helmet';
import Routes from './Routes';
import ErrorBoundary from './ErrorBoundary';
import * as S from './styled';

setConfig({
  pureSFC: true,
  logLevel: 'no-errors-please',
  onComponentCreate: type => (
    String(type).indexOf('useState') > 0
      || String(type).indexOf('useEffect') > 0
  ) && cold(type),
});

const shallowEqual = (state, newState) => {
  const { profile, namespaceIsLoaded } = state;

  return namespaceIsLoaded === newState.namespaceIsLoaded
    && profile.isLoading === newState.profile.isLoading;
};

const mapState = state => ({
  profile: coreSelectors.getProfile(state),
  ...getUiState([
    'namespace',
    'namespaceIsLoaded',
  ])(state),
});

const AppContainer = () => {
  const {
    profile,
    namespace,
    namespaceIsLoaded,
  } = useSelector(mapState, shallowEqual);
  const { pathname } = history.location;

  if (!namespaceIsLoaded) return (<Spinner />);

  return (
    <ThemeProvider
      theme={configureTheme(namespace.symbol, namespace?.settings)}
    >
      <Suspense fallback={<Spinner />}>
        <Router history={history}>
          <ErrorBoundary>
            <Flex fillSpace>
              <Routes />
              <GlobalStyle />

              {process.env.TARGET_ENV && (
                <>
                  <Analytics />

                  {profile.is_pro && pathname.startsWith('/hts-setup') === -1 && (
                    <FreshbotsWidget />
                  )}
                </>
              )}
            </Flex>
          </ErrorBoundary>
        </Router>
        <S.ToastifyContainer />
        <Helmet
          title={namespace.page_title}
          favicon={namespace.favicon}
        />
      </Suspense>
    </ThemeProvider>
  );
};

export default hot(module)(AppContainer);
